import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CharacteristicColorsResponse as SchemaCharacteristicColorsResponse } from '../schemas/CharacteristicColorsResponse';
import { type SortOrder as SchemaSortOrder } from '../schemas/SortOrder';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const GetCharacteristicColorsContentType = '' as const;
export type GetCharacteristicColorsRequest = void;
export type GetCharacteristicColorsResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of characteristic colors
     */
    '200': {
        'application/json': SchemaCharacteristicColorsResponse;
    };
};
export type GetCharacteristicColorsResponseSuccess = GetCharacteristicColorsResponses['200']['application/json'];
export type GetCharacteristicColorsSearchParams = {
    search?: string;
    sort_by?: 'value' | 'variant_count';
    sort_order?: SchemaSortOrder;
    include_count?: boolean;
};
export type GetCharacteristicColorsPathParameters = undefined;
export const GetCharacteristicColorsUrl = '/characteristics/colors' as const;
export const GetCharacteristicColorsMethod = 'GET' as const;
export const getGetCharacteristicColorsUrl = (_params?: GetCharacteristicColorsPathParameters) =>
    GetCharacteristicColorsUrl;
